import Prototype from "./Prototype";
import Vector3 from "../Utils/Vector3";
import PrototypeInput from "./PrototypeInput";

export default abstract class PrototypeManager {
  /**
   * Prototypes
   * @type {Map<string, Prototype>} <id, prototype>
   * @private
   */
  private readonly _prototypes: Map<string, Prototype> = new Map<
    string,
    Prototype
  >();

  /**
   * Blank prototype id
   * @type {string}
   * @private
   */
  private readonly _blankId: string = "";

  /**
   * @param prototypeInput
   */
  constructor(prototypeInput: PrototypeInput) {
    // Add prototypes to the map
    prototypeInput.prototypes.forEach((proto) => {
      this._prototypes.set(proto.id, proto);
    });
    this._blankId = prototypeInput.blankId;
  }

  /**
   * Get the all the possible prototype ids of a prototype in a direction
   * @param prototypeId
   * @param direction
   */
  public getPossiblePrototypeIdsInDirection(
    prototypeId: string,
    direction: Vector3,
  ): string[] {
    return this._getPrototypeById(
      prototypeId,
    ).getPossiblePrototypeIdsInDirection(direction);
  }

  private _getPrototypeById(prototypeId: string): Prototype {
    const prototype = this._prototypes.get(prototypeId);
    if (!prototype) throw new Error(`Prototype ${prototypeId} not found`);

    return prototype;
  }

  /**
   * Get a prototype by its id
   * @param prototypeId
   */
  public getPrototypeById(prototypeId: string): Prototype {
    return this._getPrototypeById(prototypeId);
  }

  /**
   * Get the prototypes list
   */
  get prototypes(): Prototype[] {
    return Array.from(this._prototypes.values());
  }

  get blankId(): string {
    return this._blankId;
  }
}
